import { Box, styled, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DirectorAccordion from './FinancialTab/DirectorAccordion'
import { useLoadingIds } from '../../hooks/useLoadingIds'
import useLoadingContext from '../../hooks/useLoadingContext'
import { useAppSnackbar } from '../../hooks/useAppSnackbar'
import {
  FetchCommunityFinancialsResponseFinancialSummary,
  financialApi,
} from '../../api/swagger'
import { useCommunitiesContext } from '../Context/CommunitiesContext'
import { useTranslation } from 'react-i18next'
import LoadingProgress from '../Elements/LoadingProgress'
import { EmptyPageCenter } from '../Elements/PageMargins'

const FinancialsContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
}))

const CommunityFinancialsTab: React.FC = () => {
  const { t } = useTranslation()
  const { handleError } = useAppSnackbar()
  const {
    Financials: { fetchCommunityFinancials: fetchCommunityFinancialsLoadingId },
  } = useLoadingIds()

  const { academicYear, selectedCommunityKey } = useCommunitiesContext()

  const [financialInfo, setFinancialInfo] = useState<
    FetchCommunityFinancialsResponseFinancialSummary[]
  >([])

  const fetchCommunityFinancials = async () => {
    try {
      if (!academicYear || !selectedCommunityKey) return

      const { financialSummary } = await financialApi.fetchCommunityFinancials({
        communityKey: selectedCommunityKey,
        academicYear: academicYear,
      })
      setFinancialInfo(financialSummary)
    } catch (error) {
      await handleError(error)
    }
  }

  const { triggerFetch, isLoading } = useLoadingContext({
    loadingId: fetchCommunityFinancialsLoadingId,
    asyncFunction: fetchCommunityFinancials,
  })

  useEffect(() => {
    if (academicYear && selectedCommunityKey) {
      triggerFetch()
    }
  }, [academicYear, selectedCommunityKey, triggerFetch])

  return (
    <FinancialsContainer>
      {isLoading ? (
        <LoadingProgress />
      ) : financialInfo.length > 0 ? (
        financialInfo.map((director) => (
          <DirectorAccordion
            key={director.actorKey}
            director={director}
            communityKey={selectedCommunityKey ?? 0}
          />
        ))
      ) : (
        <EmptyPageCenter adjustForMargins>
          <Typography component="p" variant="body1">
            {t(
              'Communities.CommunityFinancialTab.EmptyMessage',
              'No information available'
            )}
          </Typography>
        </EmptyPageCenter>
      )}
    </FinancialsContainer>
  )
}

export default CommunityFinancialsTab
